import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_40};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    gap: ${({ theme }) => theme.spacing.spacing_16};
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const LegalContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  align-items: center;
  order: 2;
  justify-content: space-between;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    justify-content: flex-start;
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    order: 1;
  }
`;

export const SocialContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_32};
  flex-direction: column;
  order: 1;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.spacing_12};
    justify-content: flex-end;
  }
`;

export const SocialList = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_12};
`;

export const LegalLinksList = styled.ul`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_12};
  margin: 0;
  padding: 0;
`;

export const LegalLink = styled.li`
  list-style: none;
`;
